var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import authentication from "@irati/auth";
import id from "@irati/utils/id";
import { injectIntl } from "@irati/utils/lang";
import { connect } from "@irati/store";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import StatusType from "@irati/wallet/types/enums/Status";
import PrimaryDetails from "../../../PrimaryDetails";
import { StyledCard } from "../../styled";
var DEFAULT_IMG = "https://res.cloudinary.com/perkbox/image/upload/v1561047597/4271b464-16f0-4e9a-8476-46a5b0576b63.png";
var SendCredit = /** @class */ (function (_super) {
    __extends(SendCredit, _super);
    function SendCredit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SendCredit.prototype.render = function () {
        var _a = this.props, statementItem = _a.statementItem, formatMessage = _a.formatMessage, wallet = _a.wallet;
        var _b = statementItem.transfer, amount = _b.amount, sendCredit = _b.sendCredit;
        var sender = sendCredit.sender, recipient = sendCredit.recipient;
        var isUserSender = authentication.user().uuid === (sender === null || sender === void 0 ? void 0 : sender.uuid);
        var title = isUserSender
            ? "wallet.statementItem.sendCredit.primaryDetails.title.sent"
            : "wallet.statementItem.sendCredit.primaryDetails.title.received";
        var subTitle = isUserSender
            ? "wallet.statementItem.sendCredit.primaryDetails.subTitle.sent"
            : "wallet.statementItem.sendCredit.primaryDetails.subTitle.received";
        var image = isUserSender ? recipient === null || recipient === void 0 ? void 0 : recipient.profile_img : sender === null || sender === void 0 ? void 0 : sender.profile_img;
        var name = isUserSender ? firstnameLastname(recipient) : firstnameLastname(sender);
        var primaryDetails = {
            image: image || DEFAULT_IMG,
            title: formatMessage({ id: title }),
            subTitle: formatMessage({ id: subTitle }, { name: name }),
            amount: amount,
            currency: wallet.currency,
            status: isUserSender ? StatusType.SPENT : StatusType.CLEARED
        };
        var idNamespace = id("send-credit-statement-item", this.props);
        return (React.createElement(StyledCard, { tiny: true, noBorder: true },
            React.createElement(PrimaryDetails, { imgHeightAuto: true, id: idNamespace, data: primaryDetails })));
    };
    return SendCredit;
}(PureComponent));
var mapStateToProps = function (_a) {
    var wallet = _a.wallet;
    return ({
        wallet: wallet
    });
};
export default injectIntl(connect(mapStateToProps)(SendCredit));
